// Re-export all API types from the service layer
export type {
  RecipeV2,
  RecipeV2Detail,
  RecipeV2ListResponse,
  RecipeComponent,
  RecipeAllergenSummary,
  AllergenTraceEntry,
  Allergen,
  ProductAllergen,
  CarbonFactor,
  ProductionMethod,
  RecipeVersion,
  AIFinding,
  CostBreakdownEntry,
  CostSimulationResult,
  DietaryAttribute,
  SupplierPrice,
  ComponentSupplierComparison,
  CreateRecipeRequest,
  CreateComponentRequest,
  ApproveRejectRequest,
  AllergenOverride,
  StockItemSearchResult,
  Equipment,
  RecipeStep,
  CreateUpdateStepRequest,
  UpdateComponentRequest,
  UpdateRecipeMetadataRequest,
  DietaryAttributeOverride,
  DietaryAttributeReference,
  ConvertToStockRequest,
  ConvertToStockResult,
  RecipeYield,
  RecipeYieldRequest,
  RecipeMenuUsage,
  RecipeNutrition,
  NutritionOverride,
  NutrientReference,
  RecipeVersionHistory,
  RecipeVersionDetail,
  RecipeVersionComponentSnapshot,
  RecipeVersionPublication,
} from '../../app/services/api/recipeV2/recipeV2Types';

export {
  RecipeStatus,
  AllergenStatus,
  AllergenSource,
  ApprovalStatus,
  AIFindingSeverity,
  AIFindingStatus,
  CarbonRating,
  DietaryCategory,
  DietaryAttributeStatus,
  RecipeKind,
} from '../../app/services/api/recipeV2/recipeV2Types';

// UI-only types
export enum RecipeV2Tab {
  Overview = 'overview',
  Ingredients = 'ingredients',
  Method = 'method',
  Costing = 'costing',
  Allergens = 'allergens',
  Dietary = 'dietary',
  Nutrition = 'nutrition',
  Usage = 'usage',
  Carbon = 'carbon',
  Versions = 'versions',
  AIInsights = 'ai-insights',
}
